import Logger from '../logger';

const onMaintenanceModeEnabledHandler = (message, callbacks) => {
    Logger.log('maintenance message: ', message);
    if (callbacks && callbacks.onMaintenanceMode) {
        callbacks.onMaintenanceMode();
    }
};

export { onMaintenanceModeEnabledHandler };
